import axios,{AxiosError, AxiosInstance} from 'axios';
import attachTokens from './attachToken';
import { deleteCookies } from '../common/utils';
import { signInUrl } from '../config';

const api: AxiosInstance = axios.create();
api.interceptors.request.use(async (config) => await attachTokens(config));

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    const requestUrl = error.config?.url || '';
    const isSignInRequest = requestUrl === signInUrl || requestUrl.includes('/firebaseAuth/signin');

    if (error.response?.status === 401 && !isSignInRequest) {
      deleteCookies();
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
